import React, { Component, PropTypes } from 'react';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import { Dialog, RaisedButton } from 'material-ui';
import UserStore from 'stores/User';
import UserActions from 'actions/User';
import StudentActions from 'actions/Student';
import ListDetail from 'components/Material/ListDetail';
import DialogPortal from 'components/DialogPortal';
import AuthActions from 'actions/Auth';
import AuthStore from 'stores/Auth';
import { FormattedMessage } from 'react-intl';

export default class SubAccounts extends mixin(
  RefluxMixin,
  Authorizer,
  Component
) {
  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object,
    title: PropTypes.string
  };

  listenToStores() {
    this.listenToStore(UserStore);
    this.listenToStore(AuthStore);
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }

    UserActions.listPwned();
  }

  selectAccount(account) {
    if (null === account) {
      this.setState({ selected: null });
    } else {
      this.setState({ selected: account });

      this.refs.incarnateAccountDialog.show();
    }
  }

  _onIncarnateAccountConfirm() {
    let account = this.state.selected || null;

    AuthActions.incarnate(parseInt(account.id, 10), () => {
      var { router } = this.props;
      router.replace(null, '/dashboard');
    });
  }

  render() {
    let accounts =
      this.state.list.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      }) || [];

    let incarnateAccountActions = [
      { text: this.context.getIntlMessage('Cancel') },
      {
        text: this.context.getIntlMessage('subAccount.incarnate'),
        onTouchTap: this._onIncarnateAccountConfirm.bind(this),
        ref: 'incarnate'
      }
    ];

    return (
      <AppPage
        header={
          <RulerBar title={this.context.getIntlMessage('Sub-Accounts')} />
        }
      >
        <ListDetail
          items={accounts}
          onTouchTapItem={this.selectAccount.bind(this)}
        />
        <DialogPortal>
          <Dialog
            ref="incarnateAccountDialog"
            title={this.context.getIntlMessage('subAccount.incarnate')}
            actions={incarnateAccountActions}
            actionFocus="Ok"
            dismissOnClickAway={true}
          >
            <FormattedMessage
              message={this.context.getIntlMessage('subAccount.attention')}
            />
            {/*<div style={{ color: 'red' }}> Attention you are going to incanate this user. Be aware that anything you change will affect the user's account </div>*/}
          </Dialog>
        </DialogPortal>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/SubAccounts.js